module.exports = __webpack_public_path__ + "static/media/1_2.ae988530.jpg";